import { analyticsService } from '../core/services';
import { VoucherBasketItemDm } from '../weborder/Api';

export const trackVoucherAdded = (newVoucher: VoucherBasketItemDm): void => {
  const voucherData = {
    amp_label: 'Voucher Applied',
    amp_voucherAmount: newVoucher.Amount,
    amp_voucherType: 'n/a',
    amp_voucherUsed: newVoucher.Name,
  };
  analyticsService.track(voucherData);
};
